import { Box, useMediaQuery } from '@mui/material';
import { Heading, Subtitle } from '../shared/typography/PrimaryTypography';

interface ContactHeaderProps {
  title: string;
}

/**
 * Styled header for internal and external user contact views.
 * @param {string} title Content of header.
 * @returns {JSX.Element}
 */
const ContactHeader = ({ title }: ContactHeaderProps) => {
  const mobile_viewport: boolean = useMediaQuery('(max-width:600px)');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        marginY: 6
      }}
    >
      {mobile_viewport ? (
        <Heading weight="Bold">{title}</Heading>
      ) : (
        <Subtitle weight="Bold">{title}</Subtitle>
      )}
    </Box>
  );
};

export default ContactHeader;
